import { windowRef } from '@util/window';
import rootReducer from "app/redux/reducers/index";
import { Context, HYDRATE, createWrapper } from "next-redux-wrapper";
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from "redux-devtools-extension";

const bindMiddleware = (middleware) => {
    if (process.env.NODE_ENV !== 'production') {
        return composeWithDevTools(applyMiddleware(...middleware))
    }
    return applyMiddleware(...middleware)
}

const reducer = (state, action) => {
    if (action.type === HYDRATE) {
        const nextState = {
            ...state, // use previous state
            ...action.payload, // apply delta from hydration
        }
        const existingStoreData = state?.store?.storeData;
        const incomingStoreData = action.payload?.store?.storeData;
        // Keep the client store only for same-store client navigations (avoids a catalogue flicker).
        // When entering a store from the multi-store picker, client storeData is empty and the
        // hydrated payload must win. When switching stores, storeIds differ so payload wins too.
        if (
            existingStoreData?.storeId &&
            incomingStoreData?.storeId &&
            existingStoreData.storeId === incomingStoreData.storeId
        ) {
            nextState.store.storeData = existingStoreData;
        }
        if (state.activeGroup) nextState.activeGroup = state.activeGroup // preserve count value on client side navigation
        if (state.membershipList) nextState.membershipList = state.membershipList
        if (state.packageList) nextState.packageList = state.packageList
        if (windowRef && windowRef?.document && windowRef?.document?.cookie) windowRef.document.cookie = `grp=${state.activeGroup}; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
        return nextState
    } else {
        return rootReducer(state, action)
    }
}

export const makeStore = (context: Context) => {
    return createStore(reducer, bindMiddleware([]))
};

export const wrapper = createWrapper(makeStore, { debug: false });
